import React, { useState, useEffect } from 'react'
import Banner1 from '../assets/banner/dashboard-banner1.jpeg';
import Banner2 from '../assets/banner/dashboard-banner2.jpeg';
import Banner3 from '../assets/banner/dashboard-banner3.jpeg';
import DailyReport from '../general/DailyReport';


const Dashboard = ({ userDetails }) => {
  const [showProfile, setShowProfile] = useState(false);
  const [showReport, setShowReport] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    category: '',
    client_id: '',
    ref_id: ''
  });

  useEffect(() => {
    if (userDetails) {
      setFormData({
        name: userDetails.name || '',
        phone: userDetails.phone || '',
        category: userDetails.category || '',
        client_id: userDetails.client_id || '',
        ref_id: userDetails.ref_id || '',
      });
    }
  }, [userDetails]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // Prepare the updated data for submission
    const updatedData = { ...formData, userId: userDetails.id };
    console.log(updatedData);

    // Here, you would typically make an API call to update the user data in the backend
    try {
      const response = await fetch('http://localhost:3002/api/update-profile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      if (response.ok) {
        alert('Profile Updated Successfully');
        setShowProfile(false); // Close the profile section after successful update
      } else {
        console.error('Failed to update profile');
      }
    } catch (error) {
      console.error('Error while updating profile:', error);
    }
  };


  return (
    <>
      {/* slider section */}
      <section className='my-lg-5 container'>
        <div className='row'>

          <div className='col-lg-9 dashboard-banner-area my-2 px-0'>
            <div id="carouselExampleIndicators" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="2000">
              <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
              </div>
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img src={Banner1} class="d-block w-100" alt="Slider" />
                </div>
                <div class="carousel-item">
                  <img src={Banner2} class="d-block w-100" alt="Slider" />
                </div>
                <div class="carousel-item">
                  <img src={Banner3} class="d-block w-100" alt="Slider" />
                </div>
              </div>
            </div>

          </div>
          {/* banner area ends */}


          <div className='col-lg-3 text-center my-4'>
            <i className="fa-solid profile-icon fa-user"></i><br />
            <button className='admin-btn px-3 py-2 mt-2 mb-3 rounded' onClick={() => setShowProfile(true)}>Manage Profile</button><br />

            <i className="fa-solid profile-icon fa-clipboard"></i><br />
            <button className='admin-btn px-3 py-2 mt-2 mb-3 rounded' onClick={() => setShowReport(true)}>Daily Report</button>

          </div>
          {/* user profile ends */}


        </div>
        {/* row ends */}
      </section>
      {/* slider section ends */}


      {/* update profile */}
      {showProfile && (
        <>
          <section className='profile-area' onClick={() => setShowProfile(false)}>
            <div className='profile-area-inner' onClick={(e) => e.stopPropagation()}>
              <i className="fa-solid fa-user profile-icon"></i><br />
              <p className='fw-bold my-3'>My Profile</p>

              <form className="row g-3 mt-4" onSubmit={handleSubmit}>
                <div className="col-12">
                  <input type="text" className="form-input" name='name' value={formData.name} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                  <input type="tel" className="form-input" name='phone' minLength={10} maxLength={10} value={formData.phone} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                  <select className="form-input" name='category' value={formData.category} onChange={handleChange} required>
                    <option className="contact-input" value="" selected disabled>Select Role</option>
                    <option className="contact-input" value="Associate">Associate</option>
                    <option className="contact-input" value="Employee">Employee</option>
                  </select>
                </div>
                <div className='col-md-6 text-start'>
                <label for="User Id" class="text-muted">User id</label>
                  <input type="text" className="form-input" name='client_id' value={formData.client_id} placeholder='Client Id' disabled />
                </div>
                <div className='col-md-6 text-start'>
                <label for="User Id" class="text-muted">Refer id</label>
                  <input type="text" className="form-input" name='ref_id' value={formData.ref_id} placeholder='Refer Id' disabled />
                </div>
                <div className="col-12 my-4">
                  <button type="submit" className="admin-btn py-3 rounded w-100">Update Profile</button>
                </div>
              </form>
              {/* form ends */}

            </div>
          </section>
        </>
      )}
      {/* update profile ends */}


      {/* daily report */}
      {showReport && <DailyReport setShowReport={setShowReport} userDetails={userDetails} />}
      {/* daily report ends */}


    </>
  )
}

export default Dashboard
